export class RoleAccessUtils {
    public static hasRole(roles: Record<string, boolean>, checkRole: string): boolean {
        if (roles.ROLE_ROOT) {
            return true;
        }

        if ('ROLE_ROOT' !== checkRole && roles.ROLE_ADMIN) {
            // ROLE_ADMIN has access to everything but ROLE_ROOT
            return true;
        }

        return roles[checkRole] || false;
    }

    /**
     * Returns true if user has at least one of the checkRoles.
     *
     * @param roles
     * @param checkRole
     */
    public static hasAnyRole(roles: Record<string, boolean>, checkRole: string[] | string): boolean {
        for (const role of RoleAccessUtils.normalizeRole(checkRole)) {
            if (RoleAccessUtils.hasRole(roles, role)) {
                return true;
            }
        }

        return false;
    }

    /**
     * Returns true only if user has ALL the checkRoles.
     *
     * @param roles
     * @param checkRole
     */
    public static hasAllRoles(roles: Record<string, boolean>, checkRole: string[] | string): boolean {
        for (const role of RoleAccessUtils.normalizeRole(checkRole)) {
            if (!RoleAccessUtils.hasRole(roles, role)) {
                return false;
            }
        }

        return true;
    }

    private static normalizeRole(checkRole: string[] | string): string[] {
        if ('string' === typeof checkRole) {
            return [checkRole];
        }

        return checkRole;
    }
}
